import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ForbiddenEventService } from './forbidden-event.service';
import { ForbiddenRouteData } from './models/forbidden-route-data.model';

@Component({
  selector: 'schaeffler-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForbiddenComponent {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly forbiddenEventService = inject(ForbiddenEventService);

  public routeData: ForbiddenRouteData;

  public constructor() {
    this.routeData = this.activatedRoute.snapshot.data;
  }

  public onActionButtonClick() {
    this.forbiddenEventService.forbiddenPageActionButtonClicked$.next();
  }
}
